import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import * as XLSX from 'xlsx';

const API = 'https://flow.wasavo.com/api';

function CampaignDetails({ campaign, onClose, API, clientId }) {
  const [messages, setMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const fetchMessages = () => {
    setLoading(true);
    fetch(API + '/campaign-messages?campaignId=' + campaign.id + '&clientId=' + clientId)
      .then(r => r.json())
      .then(d => { if(d.success) setMessages(d.messages); setLoading(false); })
      .catch(() => setLoading(false));
  };
  React.useEffect(() => { fetchMessages(); }, [campaign.id]);
  const sent = messages.filter(m=>m.status==='sent'||m.status==='delivered'||m.status==='read').length;
  const delivered = messages.filter(m=>m.status==='delivered'||m.status==='read').length;
  const read = messages.filter(m=>m.status==='read').length;
  const failed = messages.filter(m=>m.status==='failed').length;
  const actualSent = campaign.sent || sent;
  return (
    <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'24px',width:'700px',maxHeight:'85vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
          <div style={{fontSize:'18px',fontWeight:'700',color:'#1e1b4b'}}>{campaign.name}</div>
          <div style={{display:'flex',gap:'8px'}}>
            <button style={{background:'#6366f1',color:'#fff',border:'none',borderRadius:'8px',padding:'6px 14px',cursor:'pointer'}} onClick={fetchMessages}>Refresh</button>
            <button style={{background:'#6b7280',color:'#fff',border:'none',borderRadius:'8px',padding:'6px 14px',cursor:'pointer'}} onClick={onClose}>Close</button>
          </div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:'12px',marginBottom:'20px'}}>
          <div style={{background:'#eef2ff',borderRadius:'10px',padding:'14px',textAlign:'center'}}>
            <div style={{fontSize:'22px',fontWeight:'700',color:'#6366f1'}}>{actualSent}</div>
            <div style={{fontSize:'11px',color:'#6b7280',marginTop:'4px'}}>Total Sent</div>
          </div>
          <div style={{background:'#f0fdf4',borderRadius:'10px',padding:'14px',textAlign:'center'}}>
            <div style={{fontSize:'22px',fontWeight:'700',color:'#16a34a'}}>{delivered}</div>
            <div style={{fontSize:'11px',color:'#6b7280',marginTop:'4px'}}>Delivered</div>
          </div>
          <div style={{background:'#fef3c7',borderRadius:'10px',padding:'14px',textAlign:'center'}}>
            <div style={{fontSize:'22px',fontWeight:'700',color:'#d97706'}}>{read}</div>
            <div style={{fontSize:'11px',color:'#6b7280',marginTop:'4px'}}>Read</div>
          </div>
          <div style={{background:'#fef2f2',borderRadius:'10px',padding:'14px',textAlign:'center'}}>
            <div style={{fontSize:'22px',fontWeight:'700',color:'#dc2626'}}>{failed}</div>
            <div style={{fontSize:'11px',color:'#6b7280',marginTop:'4px'}}>Failed</div>
          </div>
        </div>
        <div style={{fontSize:'12px',color:'#6b7280',marginBottom:'16px',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
          <div><b>Template:</b> {campaign.template_name}</div>
          <div><b>Status:</b> {campaign.status}</div>
          <div><b>Date:</b> {campaign.created_at?new Date(campaign.created_at).toLocaleString():'-'}</div>
          <div><b>Scheduled:</b> {campaign.scheduled_at?new Date(campaign.scheduled_at).toLocaleString():'-'}</div>
        </div>
        <div style={{borderTop:'1px solid #e5e7eb',paddingTop:'16px'}}>
          <div style={{fontWeight:'600',marginBottom:'12px',color:'#374151',fontSize:'14px'}}>Per Contact Status</div>
          {loading?<div style={{textAlign:'center',padding:'20px',color:'#9ca3af'}}>Loading...</div>:
          messages.length>0?(
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
              <thead><tr style={{background:'#f9fafb'}}><th style={{padding:'8px',textAlign:'left',borderBottom:'1px solid #e5e7eb'}}>#</th><th style={{padding:'8px',textAlign:'left',borderBottom:'1px solid #e5e7eb'}}>Name</th><th style={{padding:'8px',textAlign:'left',borderBottom:'1px solid #e5e7eb'}}>Phone</th><th style={{padding:'8px',textAlign:'left',borderBottom:'1px solid #e5e7eb'}}>Sent At</th><th style={{padding:'8px',textAlign:'left',borderBottom:'1px solid #e5e7eb'}}>Status</th></tr></thead>
              <tbody>{messages.map((m,i)=>(
                <tr key={m.id} style={{borderBottom:'1px solid #f3f4f6'}}>
                  <td style={{padding:'8px',color:'#6b7280'}}>{i+1}</td>
                  <td style={{padding:'8px',fontWeight:'600'}}>{m.contact_name||m.name||'-'}</td>
                  <td style={{padding:'8px',color:'#6b7280'}}>{m.phone}</td>
                  <td style={{padding:'8px',color:'#6b7280'}}>{m.sent_at?new Date(m.sent_at).toLocaleString():'-'}</td>
                  <td style={{padding:'8px'}}><span style={{padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600',background:m.status==='failed'?'#fef2f2':m.status==='read'?'#f0fdf4':'#eef2ff',color:m.status==='failed'?'#dc2626':m.status==='read'?'#16a34a':'#6366f1'}}>{m.status}</span></td>
                </tr>
              ))}</tbody>
            </table>
          ):<div style={{textAlign:'center',padding:'20px',color:'#9ca3af'}}>No contact data yet. Send a new campaign to see details.</div>}
        </div>
      </div>
    </div>
  );
}


const P = '#4f46e5';
const DARK = '#1e2139';

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) { setError('Please enter email and password.'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
      const data = await res.json();
      if (data.success) { onLogin(data.user); }
      else { setError(data.error || 'Login failed.'); }
    } catch(e) { setError('Cannot connect to server.'); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1e2139 0%,#2d3158 50%,#1e2139 100%)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Segoe UI',sans-serif"}}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'40px',width:'380px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <img src={process.env.PUBLIC_URL + '/logo-login.png'} alt='Wasavo' style={{width:'210px',maxWidth:'100%',height:'auto',display:'block',margin:'0 auto'}}/>
          
          
        </div>
        <div style={{marginBottom:'16px'}}>
          <label style={{fontSize:'12px',fontWeight:'600',color:'#6b7280',display:'block',marginBottom:'6px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Email Address</label>
          <input style={{width:'100%',padding:'12px 14px',border:'1px solid #e5e7eb',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box',color:DARK,outline:'none'}} placeholder="Enter your email" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleLogin()}/>
        </div>
        <div style={{marginBottom:'24px'}}>
          <label style={{fontSize:'12px',fontWeight:'600',color:'#6b7280',display:'block',marginBottom:'6px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Password</label>
          <input style={{width:'100%',padding:'12px 14px',border:'1px solid #e5e7eb',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box',color:DARK,outline:'none'}} type="password" placeholder="Enter your password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleLogin()}/>
        </div>
        {error && <div style={{background:'#fef2f2',color:'#991b1b',padding:'10px 14px',borderRadius:'8px',fontSize:'13px',marginBottom:'16px'}}>{error}</div>}
        <button onClick={handleLogin} disabled={loading} style={{width:'100%',padding:'13px',background:P,color:'#fff',border:'none',borderRadius:'8px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>{loading?'Logging in...':'Login'}</button>
        <div style={{textAlign:'center',marginTop:'20px',fontSize:'12px',color:'#9ca3af'}}>Powered by Wasavo Flow</div>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('dashboard');
  const [waOpen, setWaOpen] = useState(true);
  const [campOpen, setCampOpen] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [statusOk, setStatusOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [contactLists, setContactLists] = useState([]);
  const [segments, setSegments] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [inbox, setInbox] = useState([]);
  const [autoReplies, setAutoReplies] = useState([]);
  const [newAutoReply, setNewAutoReply] = useState({ keyword: '', reply: '' });
  const [newCampaign, setNewCampaign] = useState({ name: '', message: '', listId: '' });
  const [newContact, setNewContact] = useState({ name: '', phone: '', country: '' });
  const [team, setTeam] = useState([]);
  const loadTeam = () => fetch(API+'/team-members?clientId='+user.clientId).then(r=>r.json()).then(d=>{ if(d.success) setTeam(d.members); }).catch(()=>{});
  useEffect(()=>{ if(user&&user.clientId) loadTeam(); }, []);
  const [newMember, setNewMember] = useState({ name: '', email: '', role: 'Agent', password: '' });
  const [showAddMember, setShowAddMember] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [contactPage, setContactPage] = useState(1);
  const [search, setSearch] = useState('');
  const [importPreview, setImportPreview] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [showBulkMenu, setShowBulkMenu] = useState(false); const [selectedConvo, setSelectedConvo] = useState(null); const [selectedCampaign, setSelectedCampaign] = useState(null); const [replyMsg, setReplyMsg] = useState("");

  const totalSent = campaigns.reduce((a,c)=>a+(c.sent||0),0);
  const totalRead = campaigns.reduce((a,c)=>a+(c.read||0),0);
  const readRate = totalSent>0?Math.round(totalRead/totalSent*100):0;
  const unreadCount = inbox.filter(m=>m.direction==='inbound'&&!m.is_read).length;
const prevInboxLen = React.useRef(0);
React.useEffect(()=>{
  const interval = setInterval(async ()=>{
    if(!user) return;
    const r = await fetch(`${API}/messages?clientId=${user.clientId}`);
    const d = await r.json();
    if(d.success){
      if(d.messages.length > prevInboxLen.current){
        try{ new Audio("https://www.soundjay.com/buttons/beep-01a.mp3").play(); }catch(e){}
      }
      prevInboxLen.current = d.messages.length;
      setInbox(d.messages);
    }
  },10000);
  return ()=>clearInterval(interval);
},[user]);
  useEffect(()=>{
    if(!user) return;
    fetch(`${API}/contacts?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{ if(d.success) setContacts(d.contacts); });
    fetch(`${API}/contact-lists?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{ if(d.success) setContactLists(d.lists); });
    fetch(`${API}/segments?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{ if(d.success) setSegments(d.segments); }); fetch(`${API}/campaigns?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{ if(d.success) setCampaigns(d.campaigns); }); fetch(`${API}/messages?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{ if(d.success) setInbox(d.messages); });
  },[user]);

  const handleLogin = (userData) => { setUser(userData); setPage('dashboard'); };
  const handleLogout = () => { setUser(null); setPage('dashboard'); setContacts([]); setCampaigns([]); setTemplates([]); };

  const sendMessage = async () => {
    if(!phone||!message){setStatus('Please enter phone and message.');setStatusOk(false);return;}
    setLoading(true);
    try {
      const res = await fetch(`${API}/send-message`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({phone,message,clientId:user.clientId})});
      const data = await res.json();
      if(data.success){setStatus('Message sent!');setStatusOk(true);setPhone('');setMessage('');}
      else{setStatus('Failed: '+(data.error||'Unknown'));setStatusOk(false);}
    } catch(e){setStatus('Cannot connect to server.');setStatusOk(false);}
    setLoading(false);
  };

  const sendBulkCampaign = async () => {
    if(!newCampaign.name){setStatus('Campaign name required.');setStatusOk(false);return;}
    if(!newCampaign.templateName){setStatus('Please select a template.');setStatusOk(false);return;}
    if(!newCampaign.listId&&!newCampaign.segmentId){setStatus('Please select a contact list or segment.');setStatusOk(false);return;}
    const selTemplate=templates.find(t=>t.name===newCampaign.templateName);
    const needsImage=selTemplate&&selTemplate.components&&selTemplate.components.some(c=>c.type==='HEADER'&&c.format==='IMAGE');
    if(needsImage&&!newCampaign.headerImageUrl){setStatus('This template requires a header image.');setStatusOk(false);return;}
    let targetContacts=[];
    if(newCampaign.listId) targetContacts=contacts.filter(c=>c.list_id==newCampaign.listId);
    else if(newCampaign.segmentId) targetContacts=contacts.filter(c=>c.segment_id==newCampaign.segmentId);
    if(targetContacts.length===0){setStatus('No contacts in selected list/segment.');setStatusOk(false);return;}
    setLoading(true);
    setStatus('Sending to '+targetContacts.length+' contacts...');
    let sent=0;
    const sentContacts=[];
    const _skip=(newCampaign.scheduleType==='scheduled'&&newCampaign.scheduledAt);
    for(const c of (_skip?[]:targetContacts)){
      try{
        const res=await fetch(`${API}/send-template`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({phone:c.phone,templateName:newCampaign.templateName,languageCode:templates.find(t=>t.name===newCampaign.templateName)?.language||'en_US',clientId:user.clientId,headerImageUrl:newCampaign.headerImageUrl||null})});
        const d=await res.json();
        if(d.success){sent++;sentContacts.push({phone:c.phone,name:c.name,success:true,waMessageId:d.data?.messages?.[0]?.id});}
        else{sentContacts.push({phone:c.phone,name:c.name,success:false});}
      }catch(e){sentContacts.push({phone:c.phone,name:c.name,success:false});}
    }
    const isScheduled=newCampaign.scheduleType==='scheduled'&&newCampaign.scheduledAt;
    const campRes=await fetch(`${API}/campaigns`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,name:newCampaign.name,templateName:newCampaign.templateName,listId:newCampaign.listId||null,segmentId:newCampaign.segmentId||null,sent:isScheduled?0:sent,status:isScheduled?'Scheduled':'Completed',scheduledAt:newCampaign.scheduledAt?new Date(newCampaign.scheduledAt).toISOString():null,scheduleStatus:isScheduled?'scheduled':'immediate',headerImageUrl:newCampaign.headerImageUrl||null,languageCode:templates.find(t=>t.name===newCampaign.templateName)?.language||'en_US'})});
    const campData=await campRes.json();
    if(campData.success){
      const campId = campData.campaign?.id;
      if(campId && isScheduled){for(const c of targetContacts){await fetch(API+'/campaign-message',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({campaignId:campId,clientId:user.clientId,phone:c.phone,name:c.name,status:'scheduled',waMessageId:null})});}} else if(campId && sentContacts && sentContacts.length>0){
        for(const sc of sentContacts){
          await fetch(`${API}/campaign-message`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({campaignId:campId,clientId:user.clientId,phone:sc.phone,name:sc.name,status:sc.success?'sent':'failed',waMessageId:sc.waMessageId||null})});
        }
      }
      fetch(`${API}/campaigns?clientId=${user.clientId}`).then(r=>r.json()).then(d=>{if(d.success)setCampaigns(d.campaigns);});
    }
    if(sent===0){setStatus('Campaign failed! Messages could not be delivered. Check template or contacts.');setStatusOk(false);}else if(sent<targetContacts.length){setStatus('Partially sent: '+sent+' of '+targetContacts.length+' contacts delivered.');setStatusOk(true);}else{setStatus('Campaign sent successfully to '+sent+' contacts!');setStatusOk(true);}
    setNewCampaign({name:'',message:'',listId:'',segmentId:'',templateName:'',headerImageUrl:''});setLoading(false);setPage('campaigns');
  };

  const loadTemplates = async () => {
    try{
      const res = await fetch(`${API}/get-templates?clientId=${user.clientId}`);
      const data = await res.json();
      if(data.success) setTemplates(data.templates);
      else setTemplates([]);
    }catch(e){setTemplates([]);}
  };

  const handleXLSX = (e) => {
    const file = e.target.files[0]; if(!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const wb = XLSX.read(ev.target.result,{type:'binary'});
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws,{header:1});
      const parsed = data.slice(1).map((row,i)=>({
        id:i+1,
        name:(row[0]||'').toString().trim()||'Unknown',
        phone:(row[1]||'').toString().trim(),
        country:(row[2]||'Saudi Arabia').toString().trim(),
        status:true,listId:'',segmentId:''
      })).filter(c=>c.phone);
      setImportPreview(parsed);
    };
    reader.readAsBinaryString(file);
  };

  const handleCSVFile = (e) => {
    const file = e.target.files[0]; if(!file) return;
    if(file.name.endsWith('.xlsx')||file.name.endsWith('.xls')){
      handleXLSX(e); return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const lines = ev.target.result.split('\n').filter(l=>l.trim());
      const parsed = lines.slice(1).map((line,i)=>{
        const parts = line.split(',');
        return{id:i+1,name:(parts[0]||'Unknown').trim(),phone:(parts[1]||'').trim(),country:(parts[2]||'Saudi Arabia').trim(),status:true,listId:'',segmentId:''};
      }).filter(c=>c.phone);
      setImportPreview(parsed);
    };
    reader.readAsText(file);
  };

  const doImport = async () => {
    const batchSize=200;
    const batches=[];
    for(let i=0;i<importPreview.length;i+=batchSize){ batches.push(importPreview.slice(i,i+batchSize)); }
    let total=0;
    for(const batch of batches){
      try{
        const res = await fetch(`${API}/contacts`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,contacts:batch})});
        const d = await res.json();
        if(d.success) total+=d.inserted;
      }catch(e){}
    }
    if(importPreview[0]?.listId){
      const listTitle = contactLists.find(l=>l.id==importPreview[0].listId)?.title||'Imported List';
      await fetch(`${API}/contact-lists`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,title:listTitle})});
    } else {
      await fetch(`${API}/contact-lists`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,title:'Imported List '+(contactLists.length+1)})});
    }
    const r = await fetch(`${API}/contacts?clientId=${user.clientId}`);
    const d = await r.json();
    if(d.success) setContacts(d.contacts);
    const lr = await fetch(`${API}/contact-lists?clientId=${user.clientId}`);
    const ld = await lr.json();
    if(ld.success) setContactLists(ld.lists);
    setImportPreview([]);
    setStatus(total+' contacts imported!');setStatusOk(true);
    setPage('contacts');
  };

  if(!user) return <LoginPage onLogin={handleLogin}/>;

  const s = {
    app:{display:'flex',minHeight:'100vh',background:'#f0f2f9',fontFamily:"'Segoe UI',sans-serif",fontSize:'14px'},
    sidebar:{width:sidebarOpen?'260px':'0',background:DARK,color:'#fff',transition:'width 0.3s',overflow:'hidden',flexShrink:0,display:'flex',flexDirection:'column',position:'fixed',height:'100vh',zIndex:100},
    logoBox:{padding:'18px 20px',borderBottom:'1px solid #2d3158',display:'flex',alignItems:'center',gap:'10px'},
    logoCircle:{width:'38px',height:'38px',background:'linear-gradient(135deg,#e91e8c,#ff6b35)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:'800',fontSize:'13px',flexShrink:0},
    nav:{flex:1,padding:'8px 0',overflowY:'auto'},
    navItem:(a)=>({padding:'11px 20px',cursor:'pointer',background:a?P:'transparent',color:a?'#fff':'#8b9dc3',display:'flex',alignItems:'center',gap:'12px',fontSize:'13px',fontWeight:a?'600':'400',borderRadius:a?'6px':'0',margin:a?'2px 12px':'0',transition:'all 0.2s'}),
    subItem:(a)=>({padding:'8px 20px 8px 44px',cursor:'pointer',color:a?'#fff':'#8b9dc3',fontSize:'13px',fontWeight:a?'600':'400',background:a?'rgba(79,70,229,0.3)':'transparent'}),
    menuHeader:(a)=>({padding:'11px 20px',cursor:'pointer',color:a?'#fff':'#8b9dc3',display:'flex',alignItems:'center',justifyContent:'space-between',fontSize:'13px',fontWeight:'500'}),
    main:{marginLeft:sidebarOpen?'260px':'0',flex:1,display:'flex',flexDirection:'column',minHeight:'100vh',transition:'margin 0.3s'},
    topbar:{background:'#fff',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 1px 3px rgba(0,0,0,0.08)',position:'sticky',top:0,zIndex:50},
    content:{flex:1,padding:'24px'},
    pageTitle:{fontSize:'20px',fontWeight:'700',color:'#1e2139',marginBottom:'20px'},
    kpiGrid:{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'16px',marginBottom:'24px'},
    kpiCard:{background:'#fff',borderRadius:'12px',padding:'20px',display:'flex',alignItems:'center',gap:'16px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)'},
    kpiIcon:(bg)=>({width:'48px',height:'48px',background:bg,borderRadius:'10px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'20px',flexShrink:0}),
    kpiNum:{fontSize:'22px',fontWeight:'800',color:'#1e2139'},
    kpiLabel:{fontSize:'12px',color:'#8b9dc3',marginTop:'2px'},
    card:{background:'#fff',borderRadius:'12px',padding:'20px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)',marginBottom:'20px'},
    cardTitle:{fontSize:'16px',fontWeight:'700',color:'#1e2139',marginBottom:'16px'},
    label:{fontSize:'12px',fontWeight:'600',color:'#6b7280',marginBottom:'5px',display:'block',textTransform:'uppercase',letterSpacing:'0.5px'},
    input:{width:'100%',padding:'10px 14px',border:'1px solid #e5e7eb',borderRadius:'8px',fontSize:'13px',marginBottom:'12px',boxSizing:'border-box',color:'#1e2139',background:'#fff'},
    textarea:{width:'100%',padding:'10px 14px',border:'1px solid #e5e7eb',borderRadius:'8px',fontSize:'13px',marginBottom:'12px',boxSizing:'border-box',height:'100px',resize:'vertical',color:'#1e2139'},
    btn:(bg)=>({background:bg||P,color:'#fff',border:'none',padding:'10px 20px',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'600',display:'inline-flex',alignItems:'center',gap:'6px'}),
    btnOut:{background:'#fff',color:P,border:`1px solid ${P}`,padding:'8px 16px',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'600'},
    statusMsg:(ok)=>({padding:'10px 14px',borderRadius:'8px',background:ok?'#f0fdf4':'#fef2f2',color:ok?'#166534':'#991b1b',marginTop:'10px',fontSize:'13px'}),
    table:{width:'100%',borderCollapse:'collapse',fontSize:'13px'},
    th:{background:'#f8f9ff',padding:'11px 14px',textAlign:'left',fontWeight:'600',color:'#6b7280',fontSize:'12px',borderBottom:'1px solid #e5e7eb'},
    td:{padding:'12px 14px',borderBottom:'1px solid #f3f4f6',color:'#374151',verticalAlign:'middle'},
    badge:(c)=>({background:c,color:'#fff',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700',display:'inline-block'}),
    toggle:(on)=>({width:'40px',height:'22px',background:on?P:'#d1d5db',borderRadius:'11px',cursor:'pointer',position:'relative',transition:'background 0.2s',flexShrink:0}),
    toggleDot:(on)=>({position:'absolute',top:'3px',left:on?'21px':'3px',width:'16px',height:'16px',background:'#fff',borderRadius:'50%',transition:'left 0.2s'}),
    uploadBox:{border:'2px dashed #e5e7eb',borderRadius:'10px',padding:'28px',textAlign:'center',marginBottom:'16px',background:'#fafafa'},
    emptyBox:{textAlign:'center',color:'#9ca3af',padding:'48px 20px'},
    searchInput:{padding:'8px 14px',border:'1px solid #e5e7eb',borderRadius:'8px',fontSize:'13px',width:'220px',color:'#374151'},
    select:{padding:'7px 10px',border:'1px solid #e5e7eb',borderRadius:'6px',fontSize:'13px',color:'#374151',background:'#fff'},
    row:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px',flexWrap:'wrap',gap:'10px'},
    actionBtn:(c)=>({background:'none',border:'none',color:c||'#6b7280',cursor:'pointer',fontSize:'15px',padding:'4px'}),
  };

  const Toggle = ({on,onToggle}) => (
    <div style={s.toggle(on)} onClick={onToggle}><div style={s.toggleDot(on)}/></div>
  );

  const filteredContacts = contacts.filter(c=>c.name?.toLowerCase().includes(search.toLowerCase())||c.phone?.includes(search));
  const totalPages = Math.ceil(filteredContacts.length/perPage);
  const pagedContacts = filteredContacts.slice((contactPage-1)*perPage, contactPage*perPage);

  return (
    <div style={s.app}>
      <div style={s.sidebar}>
        <div style={s.logoBox}>
          <img src={process.env.PUBLIC_URL + '/icon-192.png'} alt='Wasavo' style={{width:'40px',height:'40px',objectFit:'contain'}}/>
          <div><span style={{color:'#fff',fontWeight:'800',fontSize:'16px'}}>Wasavo</span></div>
        </div>
        <div style={{padding:'10px 12px',borderBottom:'1px solid #2d3158'}}>
          <div style={{background:'rgba(79,70,229,0.2)',borderRadius:'8px',padding:'10px 12px'}}>
            <div style={{fontSize:'11px',color:'#8b9dc3',marginBottom:'2px'}}>Logged in as</div>
            <div style={{fontSize:'13px',color:'#fff',fontWeight:'600'}}>{user.name}</div>
            <div style={{fontSize:'11px',color:'#818cf8'}}>{user.clientName}</div>
          </div>
        </div>
        <div style={s.nav}>
          <div style={s.navItem(page==='dashboard')} onClick={()=>setPage('dashboard')}>Dashboard</div>
          <div style={s.menuHeader(waOpen)} onClick={()=>setWaOpen(!waOpen)}>
            <span>WhatsApp</span><span style={{fontSize:'10px'}}>{waOpen?'v':'^'}</span>
          </div>
          {waOpen && <>
            <div style={s.subItem(page==='wa-overview')} onClick={()=>setPage('wa-overview')}>Overview</div>
            <div style={s.subItem(page==='contact-lists')} onClick={()=>setPage('contact-lists')}>Contact Lists</div>
            <div style={s.subItem(page==='segments')} onClick={()=>setPage('segments')}>Segments</div>
            <div style={s.subItem(page==='contacts')} onClick={()=>setPage('contacts')}>Contacts</div>
            <div style={s.subItem(page==='auto-replies')} onClick={()=>setPage('auto-replies')}>Auto Replies</div>
            <div style={s.subItem(page==='templates')} onClick={()=>setPage('templates')}>Templates</div>
          </>}
          <div style={s.menuHeader(campOpen)} onClick={()=>setCampOpen(!campOpen)}>
            <span>Campaigns</span><span style={{fontSize:'10px'}}>{campOpen?'v':'^'}</span>
          </div>
          {campOpen && <>
            <div style={s.subItem(page==='campaigns')} onClick={()=>setPage('campaigns')}>All Campaigns</div>
            <div style={s.subItem(page==='new-campaign')} onClick={()=>setPage('new-campaign')}>New Campaign</div>
          </>}
          <div style={s.navItem(page==='inbox')} onClick={()=>setPage('inbox')}>
            Inbox {unreadCount>0&&<span style={{background:'#ef4444',color:'#fff',borderRadius:'10px',padding:'1px 7px',fontSize:'11px',marginLeft:'auto'}}>{unreadCount}</span>}
          </div>
          <div style={s.navItem(page==='team')} onClick={()=>setPage('team')}>Team Member</div>
          <div style={s.navItem(page==='ticket')} onClick={()=>setPage('ticket')}>My Ticket</div>
          <div style={s.menuHeader(aiOpen)} onClick={()=>setAiOpen(!aiOpen)}>
            <span>AI Assistant</span><span style={{fontSize:'10px'}}>{aiOpen?'v':'^'}</span>
          </div>
          {aiOpen&&<div style={s.subItem(page==='ai-chat')} onClick={()=>setPage('ai-chat')}>AI Chat</div>}
          <div style={s.menuHeader(settingOpen)} onClick={()=>setSettingOpen(!settingOpen)}>
            <span>Setting</span><span style={{fontSize:'10px'}}>{settingOpen?'v':'^'}</span>
          </div>
          {settingOpen&&<>
            <div style={s.subItem(page==='settings-profile')} onClick={()=>setPage('settings-profile')}>Profile</div>
            <div style={s.subItem(page==='settings-billing')} onClick={()=>setPage('settings-billing')}>Billing</div>
            <div style={s.subItem(page==='settings-api')} onClick={()=>setPage('settings-api')}>API Keys</div>
          </>}
          <div style={s.navItem(page==='api-docs')} onClick={()=>setPage('api-docs')}>API</div>
        </div>
        <div style={{padding:'12px',borderTop:'1px solid #2d3158'}}>
          <button onClick={handleLogout} style={{width:'100%',padding:'10px',background:'#dc2626',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'600'}}>Logout</button>
        </div>
      </div>

      <div style={s.main}>
        <div style={s.topbar}>
          <button onClick={()=>setSidebarOpen(!sidebarOpen)} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'#6b7280'}}>☰</button>
          <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
            <span style={{fontSize:'12px',color:'#6b7280',background:'#eef2ff',padding:'4px 12px',borderRadius:'20px'}}>{user.clientName}</span>
            <div style={{width:'34px',height:'34px',background:`linear-gradient(135deg,${P},#818cf8)`,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:'700',fontSize:'13px'}}>{user.name.charAt(0)}</div>
            <span style={{fontSize:'13px',fontWeight:'600',color:'#1e2139'}}>{user.name}</span>
          </div>
        </div>

        <div style={s.content}>

          {page==='dashboard'&&(
            <div>
              <div style={s.pageTitle}>Dashboard</div>
              <div style={s.kpiGrid}>
                <div style={s.kpiCard}><div style={s.kpiIcon('#eef2ff')}><span style={{color:P,fontSize:'20px',fontWeight:'700'}}>G</span></div><div><div style={s.kpiNum}>{contacts.length}</div><div style={s.kpiLabel}>Total Contacts</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#f0fdf4')}><span style={{color:'#16a34a',fontSize:'20px',fontWeight:'700'}}>S</span></div><div><div style={{...s.kpiNum,color:'#16a34a'}}>{totalSent}</div><div style={s.kpiLabel}>Messages Sent</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#fff7ed')}><span style={{color:'#ea580c',fontSize:'20px',fontWeight:'700'}}>R</span></div><div><div style={{...s.kpiNum,color:'#ea580c'}}>{readRate}%</div><div style={s.kpiLabel}>Read Rate</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#fef2f2')}><span style={{color:'#dc2626',fontSize:'20px',fontWeight:'700'}}>C</span></div><div><div style={{...s.kpiNum,color:'#dc2626'}}>{campaigns.length}</div><div style={s.kpiLabel}>Campaigns</div></div></div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'20px'}}>
                <div style={s.card}>
                  <div style={s.cardTitle}>Recent Campaigns</div>
                  {campaigns.length>0?(
                    <table style={s.table}><thead><tr><th style={s.th}>Campaign</th><th style={s.th}>Sent</th><th style={s.th}>Status</th></tr></thead>
                    <tbody>{campaigns.slice(-5).map(c=>(<tr key={c.id}><td style={s.td}>{c.name}</td><td style={s.td}>{c.sent}</td><td style={s.td}><span style={s.badge('#16a34a')}>{c.status}</span></td></tr>))}</tbody></table>
                  ):<div style={s.emptyBox}><div>No campaigns yet</div><br/><button style={s.btn()} onClick={()=>setPage('new-campaign')}>+ New Campaign</button></div>}
                </div>
                <div style={s.card}>
                  <div style={s.cardTitle}>Quick Actions</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
                    {[{label:'Send Message',pg:'send',color:'#eef2ff'},{label:'Add Contacts',pg:'contacts',color:'#f0fdf4'},{label:'New Campaign',pg:'new-campaign',color:'#fff7ed'},{label:'Templates',pg:'templates',color:'#fdf4ff'}].map((q,i)=>(
                      <div key={i} onClick={()=>setPage(q.pg)} style={{background:q.color,borderRadius:'10px',padding:'16px',textAlign:'center',cursor:'pointer',border:'1px solid #e5e7eb'}}>
                        <div style={{fontSize:'12px',fontWeight:'600',color:'#374151'}}>{q.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {page==='wa-overview'&&(
            <div>
              <div style={s.pageTitle}>WhatsApp Overview</div>
              <div style={s.kpiGrid}>
                <div style={s.kpiCard}><div style={s.kpiIcon('#eef2ff')}><span style={{color:P}}>G</span></div><div><div style={{...s.kpiNum,color:P}}>{contacts.length}</div><div style={s.kpiLabel}>Total Contacts</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#f0fdf4')}><span style={{color:'#16a34a'}}>A</span></div><div><div style={{...s.kpiNum,color:'#16a34a'}}>{contacts.filter(c=>c.status).length}</div><div style={s.kpiLabel}>Active</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#fff7ed')}><span style={{color:'#ea580c'}}>R</span></div><div><div style={{...s.kpiNum,color:'#ea580c'}}>{readRate}%</div><div style={s.kpiLabel}>Read Rate</div></div></div>
                <div style={s.kpiCard}><div style={s.kpiIcon('#fef2f2')}><span style={{color:'#dc2626'}}>C</span></div><div><div style={{...s.kpiNum,color:'#dc2626'}}>{campaigns.length}</div><div style={s.kpiLabel}>Campaigns</div></div></div>
              </div>
              <div style={s.card}>
                <div style={s.cardTitle}>Audience Growth</div>
                {contacts.length>0?(
                  <ResponsiveContainer width="100%" height={280}>
                    <LineChart data={[{month:'Now',total:contacts.length}]}>
                      <CartesianGrid strokeDasharray="3 3"/><XAxis dataKey="month"/><YAxis/><Tooltip/><Legend/>
                      <Line type="monotone" dataKey="total" stroke={P} strokeWidth={2} name="Contacts"/>
                    </LineChart>
                  </ResponsiveContainer>
                ):<div style={s.emptyBox}><div>No data yet.</div></div>}
              </div>
            </div>
          )}

          {page==='contact-lists'&&(
            <div>
              <div style={s.row}>
                <div style={s.pageTitle}>Contact Lists</div>
                <button style={s.btn()} onClick={async()=>{
                  const t=prompt('List name:');
                  if(!t) return;
                  const res=await fetch(`${API}/contact-lists`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,title:t})});
                  const d=await res.json();
                  if(d.success) setContactLists(prev=>[...prev,d.list]);
                }}>+ Add New</button>
              </div>
              <div style={s.card}>
                {contactLists.length>0?(
                  <table style={s.table}>
                    <thead><tr><th style={s.th}>#</th><th style={s.th}>Title</th><th style={s.th}>Action</th></tr></thead>
                    <tbody>{contactLists.map((l,i)=>(<tr key={l.id}><td style={s.td}>{i+1}</td><td style={s.td}><b>{l.title}</b></td>
                    <td style={s.td}><button style={s.actionBtn('#dc2626')} onClick={async()=>{
                      await fetch(`${API}/contact-lists/${l.id}`,{method:'DELETE'});
                      setContactLists(prev=>prev.filter(x=>x.id!==l.id));
                    }}>Del</button></td></tr>))}</tbody>
                  </table>
                ):<div style={s.emptyBox}><div>No lists yet.</div></div>}
              </div>
            </div>
          )}

          {page==='segments'&&(
            <div>
              <div style={s.row}>
                <div style={s.pageTitle}>Segments</div>
                <button style={s.btn()} onClick={async()=>{
                  const n=prompt('Segment name:');
                  if(!n) return;
                  const res=await fetch(`${API}/segments`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,name:n})});
                  const d=await res.json();
                  if(d.success) setSegments(prev=>[...prev,d.segment]);
                }}>+ Add New</button>
              </div>
              <div style={s.card}>
                {segments.length>0?(
                  <table style={s.table}>
                    <thead><tr><th style={s.th}>#</th><th style={s.th}>Name</th><th style={s.th}>Status</th><th style={s.th}>Action</th></tr></thead>
                    <tbody>{segments.map((seg,i)=>(<tr key={seg.id}><td style={s.td}>{i+1}</td><td style={s.td}><b>{seg.name}</b></td>
                    <td style={s.td}><Toggle on={seg.active} onToggle={()=>setSegments(prev=>prev.map(s=>s.id===seg.id?{...s,active:!s.active}:s))}/></td>
                    <td style={s.td}><button style={s.actionBtn('#dc2626')} onClick={async()=>{
                      await fetch(`${API}/segments/${seg.id}`,{method:'DELETE'});
                      setSegments(prev=>prev.filter(x=>x.id!==seg.id));
                    }}>Del</button></td></tr>))}</tbody>
                  </table>
                ):<div style={s.emptyBox}><div>No segments yet.</div></div>}
              </div>
            </div>
          )}

          {page==='contacts'&&(
            <div>
              <div style={s.row}>
                <div style={s.pageTitle}>Contacts <span style={{fontSize:'14px',color:'#6b7280',fontWeight:'400'}}>({contacts.length} total)</span></div>
                <div style={{display:'flex',gap:'8px'}}>
                 <div style={{position:'relative'}}>
  <button style={s.btn('#6366f1')} onClick={()=>setShowBulkMenu(!showBulkMenu)}>Bulk Action</button>
  {showBulkMenu&&(
    <div style={{position:'absolute',top:'40px',left:0,background:'#fff',borderRadius:'8px',boxShadow:'0 4px 20px rgba(0,0,0,0.15)',zIndex:100,minWidth:'180px',padding:'8px 0'}}>
      {['Add List','Remove List','Add Segment','Remove Segment','Add Blacklist','Remove Blacklist','Delete Contacts'].map((item,i)=>(
        <div key={i} onClick={async()=>{
          if(item==='Delete Contacts'){
            if(selectedContacts.length===0){alert('Select contacts first');return;}
            for(const id of selectedContacts){ await fetch(`${API}/contacts/${id}`,{method:'DELETE'}); }
            setContacts(prev=>prev.filter(c=>!selectedContacts.includes(c.id)));
            setSelectedContacts([]);
          } else if(item==='Add List'){
            if(selectedContacts.length===0){alert('Select contacts first');return;}
            const listId=prompt('Select list ID - Available: '+contactLists.map(l=>l.id+':'+l.title).join(', '));
            if(listId) setContacts(prev=>prev.map(c=>selectedContacts.includes(c.id)?{...c,list_id:Number(listId)}:c));
          } else if(item==='Remove List'){
            if(selectedContacts.length===0){alert('Select contacts first');return;}
            setContacts(prev=>prev.map(c=>selectedContacts.includes(c.id)?{...c,list_id:null}:c));
          } else if(item==='Add Segment'){
            if(selectedContacts.length===0){alert('Select contacts first');return;}
            const segId=prompt('Select segment ID - Available: '+segments.map(s=>s.id+':'+s.name).join(', '));
            if(segId) setContacts(prev=>prev.map(c=>selectedContacts.includes(c.id)?{...c,segment_id:Number(segId)}:c));
          } else if(item==='Remove Segment'){
            if(selectedContacts.length===0){alert('Select contacts first');return;}
            setContacts(prev=>prev.map(c=>selectedContacts.includes(c.id)?{...c,segment_id:null}:c));
          }
          setShowBulkMenu(false);
        }} style={{padding:'10px 16px',cursor:'pointer',fontSize:'13px',color:item==='Delete Contacts'?'#dc2626':'#374151',borderBottom:'1px solid #f3f4f6'}}
        onMouseOver={e=>e.target.style.background='#f8f9ff'} onMouseOut={e=>e.target.style.background='transparent'}>
          {item}
        </div>
      ))}
    </div>
  )}
</div>
                  <button style={s.btn()} onClick={()=>setPage('add-contact')}>+ Add New</button>
                  <button style={s.btn('#16a34a')} onClick={()=>setPage('import-contacts')}>Import XLSX</button>
                </div>
              </div>
              <div style={s.card}>
                <div style={s.row}>
                  <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <select style={s.select} value={perPage} onChange={e=>{setPerPage(Number(e.target.value));setContactPage(1);}}>
                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="500">500</option>
                    </select>
                    <span style={{fontSize:'13px',color:'#6b7280'}}>Per Page</span>
                  </div>
                  <input style={s.searchInput} placeholder="Search name or phone..." value={search} onChange={e=>{setSearch(e.target.value);setContactPage(1);}}/>
                </div>
                {pagedContacts.length>0?(
                  <div>
                    <div style={{overflowX:'auto'}}>
                      <table style={s.table}>
                        <thead><tr><th style={s.th}>#</th><th style={s.th}>Name</th><th style={s.th}>Phone</th><th style={s.th}>Country</th><th style={s.th}>Contact List</th><th style={s.th}>Segment</th><th style={s.th}>Status</th><th style={s.th}>Action</th></tr></thead>
                        <tbody>{pagedContacts.map((c,i)=>(
                          <tr key={c.id}>
                            <td style={s.td}>{(contactPage-1)*perPage+i+1}</td>
                            <td style={s.td}><b>{c.name}</b></td>
                            <td style={s.td}>{c.phone}</td>
                            <td style={s.td}>{c.country}</td>
                            <td style={s.td}><span style={{fontSize:'12px',color:P}}>{contactLists.find(l=>l.id===c.list_id)?.title||'-'}</span></td>
                            <td style={s.td}><span style={{fontSize:'12px',color:'#6b7280'}}>{segments.find(seg=>seg.id===c.segment_id)?.name||'-'}</span></td>
                            <td style={s.td}><Toggle on={c.status} onToggle={()=>setContacts(prev=>prev.map(x=>x.id===c.id?{...x,status:!x.status}:x))}/></td>
                            <td style={s.td}><button style={s.actionBtn('#dc2626')} onClick={async()=>{await fetch(`${API}/contacts/${c.id}`,{method:'DELETE'});setContacts(prev=>prev.filter(x=>x.id!==c.id));}}>Del</button></td>
                          </tr>
                        ))}</tbody>
                      </table>
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'16px',flexWrap:'wrap',gap:'8px'}}>
                      <div style={{fontSize:'13px',color:'#6b7280'}}>Showing {Math.min((contactPage-1)*perPage+1,filteredContacts.length)} to {Math.min(contactPage*perPage,filteredContacts.length)} of {filteredContacts.length}</div>
                      <div style={{display:'flex',gap:'6px'}}>
                        <button style={{...s.btnOut,padding:'6px 12px'}} disabled={contactPage===1} onClick={()=>setContactPage(1)}>First</button>
                        <button style={{...s.btnOut,padding:'6px 12px'}} disabled={contactPage===1} onClick={()=>setContactPage(p=>p-1)}>Prev</button>
                        <span style={{padding:'6px 12px',background:P,color:'#fff',borderRadius:'6px',fontSize:'13px'}}>{contactPage} / {totalPages}</span>
                        <button style={{...s.btnOut,padding:'6px 12px'}} disabled={contactPage>=totalPages} onClick={()=>setContactPage(p=>p+1)}>Next</button>
                        <button style={{...s.btnOut,padding:'6px 12px'}} disabled={contactPage>=totalPages} onClick={()=>setContactPage(totalPages)}>Last</button>
                      </div>
                    </div>
                  </div>
                ):<div style={s.emptyBox}><div>No contacts yet.</div></div>}
              </div>
            </div>
          )}

          {page==='add-contact'&&(
            <div>
              <div style={s.row}><div style={s.pageTitle}>Add Contact</div><button style={s.btnOut} onClick={()=>setPage('contacts')}>Back</button></div>
              <div style={s.card}>
                <label style={s.label}>Name</label>
                <input style={s.input} placeholder="Full Name" value={newContact.name} onChange={e=>setNewContact({...newContact,name:e.target.value})}/>
                <label style={s.label}>Phone (With Country Code)</label>
                <input style={s.input} placeholder="+966XXXXXXXXX" value={newContact.phone} onChange={e=>setNewContact({...newContact,phone:e.target.value})}/>
                <label style={s.label}>Contact List</label>
                <select style={{...s.input}} onChange={e=>setNewContact({...newContact,listId:e.target.value})}>
                  <option value="">Select List</option>
                  {contactLists.map(l=><option key={l.id} value={l.id}>{l.title}</option>)}
                </select>
                <label style={s.label}>Segment</label>
                <select style={{...s.input}} onChange={e=>setNewContact({...newContact,segmentId:e.target.value})}>
                  <option value="">Select Segment</option>
                  {segments.map(seg=><option key={seg.id} value={seg.id}>{seg.name}</option>)}
                </select>
                <label style={s.label}>Country</label>
                <select style={{...s.input}} value={newContact.country} onChange={e=>setNewContact({...newContact,country:e.target.value})}>
                  <option value="">Select Country</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="UAE">UAE</option>
                  <option value="India">India</option>
                  <option value="USA">USA</option>
                </select>
                <button style={s.btn()} onClick={async()=>{
                  if(!newContact.name||!newContact.phone){setStatus('Name and phone required.');setStatusOk(false);return;}
                  const res=await fetch(`${API}/contacts`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,contacts:[newContact]})});
                  const d=await res.json();
                  if(d.success){
                    const r=await fetch(`${API}/contacts?clientId=${user.clientId}`);
                    const rd=await r.json();
                    if(rd.success) setContacts(rd.contacts);
                    setStatus('Contact added!');setStatusOk(true);
                    setNewContact({name:'',phone:'',country:''});setPage('contacts');
                  }
                }}>Save Contact</button>
                {status&&<div style={s.statusMsg(statusOk)}>{status}</div>}
              </div>
            </div>
          )}

          {page==='import-contacts'&&(
            <div>
              <div style={s.row}>
                <div style={s.pageTitle}>Import Contacts</div>
                <button style={s.btnOut} onClick={()=>setPage('contacts')}>Back</button>
              </div>
              <div style={s.card}>
                <div style={{color:'#dc2626',fontSize:'13px',marginBottom:'12px'}}>
                  <b>Note:</b> Only .xlsx files accepted. Include phone numbers with country codes (e.g. 966XXXXXXXXX).{' '}
                  <span style={{color:P,cursor:'pointer',fontWeight:'600',textDecoration:'underline'}} onClick={()=>{const a=document.createElement('a');a.href='/sample-contacts.csv';a.download='sample-contacts.csv';a.click();}}>Download sample file here.</span>
                </div>
                <div style={s.uploadBox}>
                  <div style={{fontSize:'16px',fontWeight:'600',marginBottom:'8px'}}>Choose File (.xlsx or .csv)</div>
                  <input type="file" accept=".xlsx,.xls,.csv" onChange={handleCSVFile}/>
                </div>
              </div>
              {importPreview.length>0&&(
                <div style={s.card}>
                  <div style={{display:'flex',gap:'12px',alignItems:'center',marginBottom:'16px',flexWrap:'wrap'}}>
                    <div style={{fontSize:'13px',color:'#16a34a',fontWeight:'600'}}>{importPreview.length} contacts ready to import</div>
                    <select style={s.select} onChange={e=>{const v=e.target.value;setImportPreview(prev=>prev.map(x=>({...x,listId:v})));}}> 
                      <option value="">Apply List to All</option>
                      {contactLists.map(l=><option key={l.id} value={l.id}>{l.title}</option>)}
                    </select>
                    <select style={s.select} onChange={e=>{const v=e.target.value;setImportPreview(prev=>prev.map(x=>({...x,segmentId:v})));}}>
                      <option value="">Apply Segment to All</option>
                      {segments.map(seg=><option key={seg.id} value={seg.id}>{seg.name}</option>)}
                    </select>
                  </div>
                  <div style={{overflowX:'auto',overflowY:'auto',maxHeight:'400px'}}>
                    <table style={s.table}>
                      <thead><tr><th style={s.th}>#</th><th style={s.th}>Name</th><th style={s.th}>Phone</th><th style={s.th}>Contact List</th><th style={s.th}>Segment</th></tr></thead>
                      <tbody>{importPreview.map((c,i)=>(
                        <tr key={i}>
                          <td style={s.td}>{i+1}</td>
                          <td style={s.td}>{c.name}</td>
                          <td style={s.td}>{c.phone}</td>
                          <td style={s.td}>
                            <select style={s.select} value={c.listId||''} onChange={e=>setImportPreview(prev=>prev.map((x,xi)=>xi===i?{...x,listId:e.target.value}:x))}>
                              <option value="">Select List</option>
                              {contactLists.map(l=><option key={l.id} value={l.id}>{l.title}</option>)}
                            </select>
                          </td>
                          <td style={s.td}>
                            <select style={s.select} value={c.segmentId||''} onChange={e=>setImportPreview(prev=>prev.map((x,xi)=>xi===i?{...x,segmentId:e.target.value}:x))}>
                              <option value="">Select Segment</option>
                              {segments.map(seg=><option key={seg.id} value={seg.id}>{seg.name}</option>)}
                            </select>
                          </td>
                        </tr>
                      ))}</tbody>
                    </table>
                  </div>
                  <button style={{...s.btn('#16a34a'),marginTop:'16px'}} onClick={doImport}>Import {importPreview.length} Contacts</button>
                </div>
              )}
            </div>
          )}

          {page==='send'&&(
            <div>
              <div style={s.pageTitle}>Send Message</div>
              <div style={s.card}>
                <label style={s.label}>Phone Number</label>
                <input style={s.input} placeholder="Phone with country code" value={phone} onChange={e=>setPhone(e.target.value)}/>
                <label style={s.label}>Message</label>
                <textarea style={s.textarea} placeholder="Type message..." value={message} onChange={e=>setMessage(e.target.value)}/>
                <button style={s.btn()} onClick={sendMessage} disabled={loading}>{loading?'Sending...':'Send Message'}</button>
                {status&&<div style={s.statusMsg(statusOk)}>{status}</div>}
              </div>
            </div>
          )}

          {page==='auto-replies'&&(
            <div>
              <div style={s.pageTitle}>Auto Replies</div>
              <div style={{...s.card,borderLeft:`4px solid ${P}`}}>
                <label style={s.label}>Keyword</label>
                <input style={s.input} placeholder="e.g. hello, price" value={newAutoReply.keyword} onChange={e=>setNewAutoReply({...newAutoReply,keyword:e.target.value})}/>
                <label style={s.label}>Reply Message</label>
                <textarea style={{...s.textarea,height:'80px'}} value={newAutoReply.reply} onChange={e=>setNewAutoReply({...newAutoReply,reply:e.target.value})}/>
                <button style={s.btn()} onClick={()=>{if(!newAutoReply.keyword||!newAutoReply.reply)return;setAutoReplies(prev=>[...prev,{id:prev.length+1,...newAutoReply,active:true}]);setNewAutoReply({keyword:'',reply:''});}}>+ Add</button>
              </div>
              <div style={s.card}>
                {autoReplies.length>0?(
                  <table style={s.table}>
                    <thead><tr><th style={s.th}>#</th><th style={s.th}>Keyword</th><th style={s.th}>Reply</th><th style={s.th}>Status</th><th style={s.th}>Action</th></tr></thead>
                    <tbody>{autoReplies.map(ar=>(<tr key={ar.id}><td style={s.td}>{ar.id}</td><td style={s.td}><b>{ar.keyword}</b></td><td style={s.td}>{ar.reply.substring(0,50)}</td><td style={s.td}><Toggle on={ar.active} onToggle={()=>setAutoReplies(prev=>prev.map(r=>r.id===ar.id?{...r,active:!r.active}:r))}/></td><td style={s.td}><button style={s.actionBtn('#dc2626')} onClick={()=>setAutoReplies(prev=>prev.filter(x=>x.id!==ar.id))}>Del</button></td></tr>))}</tbody>
                  </table>
                ):<div style={s.emptyBox}><div>No auto replies yet.</div></div>}
              </div>
            </div>
          )}

          {page==='templates'&&(
            <div>
              <div style={s.row}>
                <div style={s.pageTitle}>Template Management</div>
                <div style={{display:'flex',gap:'8px'}}>
                  <button style={s.btn()} onClick={loadTemplates}>Load Templates</button>
                  <button style={s.btn('#1877f2')} onClick={()=>window.open('https://business.facebook.com/wa/manage/message-templates/','_blank')}>Create on Facebook</button>
                </div>
              </div>
              <div style={{...s.card,padding:'12px 20px',marginBottom:'16px'}}>
                <span style={{fontSize:'13px',color:'#6b7280'}}>Client: </span>
                <span style={{fontSize:'13px',fontWeight:'700',color:P}}>{user.clientName}</span>
              </div>
              {templates.length>0?(
                <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))',gap:'16px'}}>
                  {templates.map((t,i)=>(
                    <div key={i} style={{background:'white',borderRadius:'12px',padding:'20px',border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.08)'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'12px'}}>
                        <div style={{fontSize:'15px',fontWeight:'700',color:'#1e2139'}}>{t.name}</div>
                        <div style={{padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'600',background:t.status==='APPROVED'?'#dcfce7':t.status==='PENDING'?'#fef9c3':'#fee2e2',color:t.status==='APPROVED'?'#16a34a':t.status==='PENDING'?'#ca8a04':'#dc2626'}}>{t.status}</div>
                      </div>
                      <div style={{fontSize:'12px',color:'#6b7280',marginBottom:'10px'}}>{t.category} - {t.language}</div>
                      {t.components&&t.components.map((comp,j)=>comp.text&&(
                        <div key={j} style={{background:'#f8fafc',borderRadius:'8px',padding:'10px',marginBottom:'6px',fontSize:'12px',color:'#374151'}}>
                          <span style={{fontWeight:'600',color:P}}>{comp.type}: </span>{comp.text}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ):(
                <div style={s.card}><div style={s.emptyBox}><div style={{marginBottom:'12px'}}>Click "Load Templates" to fetch from Meta</div><button style={s.btn('#1877f2')} onClick={()=>window.open('https://business.facebook.com/wa/manage/message-templates/','_blank')}>Create Template on Facebook</button></div></div>
              )}
            </div>
          )}

          {page==='new-campaign'&&(
            <div>
              <div style={s.pageTitle}>New Campaign</div>
              <div style={s.card}>
                <label style={s.label}>Campaign Name *</label>
                <input style={s.input} placeholder="Campaign name" value={newCampaign.name} onChange={e=>setNewCampaign({...newCampaign,name:e.target.value})}/>
                <label style={s.label}>Select Contact List *</label>
                <select style={{...s.input}} value={newCampaign.listId||''} onChange={e=>setNewCampaign({...newCampaign,listId:e.target.value,segmentId:''})}>
                  <option value="">-- Select Contact List --</option>
                  {contactLists.map(l=><option key={l.id} value={l.id}>{l.title}</option>)}
                </select>
                <label style={s.label}>OR Select Segment</label>
                <select style={{...s.input}} value={newCampaign.segmentId||''} onChange={e=>setNewCampaign({...newCampaign,segmentId:e.target.value,listId:''})}>
                  <option value="">-- Select Segment --</option>
                  {segments.map(seg=><option key={seg.id} value={seg.id}>{seg.name}</option>)}
                </select>
                <label style={s.label}>Select Template *</label>
                <div style={{display:'flex',gap:'8px',marginBottom:'12px'}}>
                  <select style={{...s.input,marginBottom:0,flex:1}} value={newCampaign.templateName||''} onChange={e=>setNewCampaign({...newCampaign,templateName:e.target.value})}>
                    <option value="">-- Select Template --</option>
                    {templates.map((t,i)=><option key={i} value={t.name}>{t.name} ({t.status})</option>)}
                  </select>
                  <button style={s.btn('#6b7280')} onClick={loadTemplates}>Load</button>
                </div>
                {newCampaign.templateName&&templates.find(t=>t.name===newCampaign.templateName)?.components?.some(c=>c.type==='HEADER'&&c.format==='IMAGE')&&(<div><label style={s.label}>Header Image URL (Required) *</label><input style={s.input} placeholder="https://example.com/image.jpg" value={newCampaign.headerImageUrl||''} onChange={e=>setNewCampaign({...newCampaign,headerImageUrl:e.target.value})} readOnly/><input type="file" accept="image/*" style={{marginTop:'8px',width:'100%'}} onChange={async e=>{const f=e.target.files[0];if(!f)return;const fd=new FormData();fd.append('image',f);const r=await fetch(`${API}/upload-image`,{method:'POST',body:fd});const d=await r.json();if(d.success)setNewCampaign(prev=>({...prev,headerImageUrl:d.url}));}}/>  </div>)}
                {newCampaign.templateName&&templates.find(t=>t.name===newCampaign.templateName)&&(
                  <div style={{background:'#f8fafc',borderRadius:'8px',padding:'12px',marginBottom:'12px',fontSize:'13px'}}>
                    <div style={{fontWeight:'600',color:'#6366f1',marginBottom:'6px'}}>Template Preview:</div>
                    {templates.find(t=>t.name===newCampaign.templateName)?.components?.map((comp,i)=>(
                      comp.text&&<div key={i} style={{color:'#374151',marginBottom:'4px'}}><span style={{fontWeight:'600',color:'#6b7280'}}>{comp.type}: </span>{comp.text}</div>
                    ))}
                  </div>
                )}
                <div style={{background:'#eef2ff',borderRadius:'8px',padding:'12px',marginBottom:'16px',fontSize:'13px',color:'#374151'}}>
                  <b>Recipients: </b>
                  {newCampaign.listId ? contacts.filter(c=>c.list_id==newCampaign.listId).length+' contacts from selected list' :
                   newCampaign.segmentId ? contacts.filter(c=>c.segment_id==newCampaign.segmentId).length+' contacts from selected segment' :
                   'Select a list or segment above'}
                </div>
                <label style={s.label}>Schedule (optional)</label>
                <div style={{display:'flex',gap:'8px',marginBottom:'12px'}}>
                  <select style={{...s.input,marginBottom:0,flex:1}} value={newCampaign.scheduleType||'immediate'} onChange={e=>setNewCampaign({...newCampaign,scheduleType:e.target.value})}>
                    <option value='immediate'>Send Now</option>
                    <option value='scheduled'>Schedule for Later</option>
                  </select>
                </div>
                {newCampaign.scheduleType==='scheduled'&&<div><label style={s.label}>Date & Time</label><input type='datetime-local' style={{...s.input}} value={newCampaign.scheduledAt||''} onChange={e=>setNewCampaign({...newCampaign,scheduledAt:e.target.value})}/></div>}
                <button style={{...s.btn(),width:'100%',justifyContent:'center',padding:'12px'}} onClick={sendBulkCampaign} disabled={loading||(!newCampaign.listId&&!newCampaign.segmentId)||!newCampaign.templateName||!newCampaign.name}>
                  {loading?'Sending... please wait':newCampaign.scheduleType==='scheduled'?'Schedule Campaign':'Send Campaign'}
                </button>
                {status&&<div style={s.statusMsg(statusOk)}>{status}</div>}
              </div>
            </div>
          )}

          {page==='campaigns'&&(
            <div>
              <div style={s.row}><div style={s.pageTitle}>Campaigns</div><button style={s.btn()} onClick={()=>setPage('new-campaign')}>+ New</button></div>
              <div style={s.card}>
                {campaigns.length>0?(
                  <table style={s.table}>
                    <thead><tr><th style={s.th}>#</th><th style={s.th}>Name</th><th style={s.th}>Date</th><th style={s.th}>Sent</th><th style={s.th}>Read</th><th style={s.th}>Status</th><th style={s.th}>Action</th></tr></thead>
                    <tbody>{campaigns.map(c=>(<tr key={c.id}><td style={s.td}>{c.id}</td><td style={s.td}><b>{c.name}</b></td><td style={s.td}>{c.created_at ? new Date(c.created_at).toLocaleDateString() : "-"}</td><td style={s.td}>{c.sent}</td><td style={s.td}>{c.read_count||0}</td><td style={s.td}><span style={s.badge(c.status==='Scheduled'?'#f59e0b':'#16a34a')}>{c.status}</span></td><td style={s.td}><button style={{...s.btn('#6366f1'),padding:'4px 12px',fontSize:'12px'}} onClick={()=>setSelectedCampaign(c)}>Details</button></td></tr>))}</tbody>
                  </table>
                ):<div style={s.emptyBox}><div>No campaigns yet</div><br/><button style={s.btn()} onClick={()=>setPage('new-campaign')}>+ Create</button></div>}
              </div>
            </div>
          )}

          {selectedCampaign&&(
            <CampaignDetails campaign={selectedCampaign} onClose={()=>setSelectedCampaign(null)} API={API} clientId={user.clientId} />
          )}

          {page==='inbox'&&(
            <div style={{display:'flex',gap:'16px',height:'calc(100vh - 140px)'}}>
              <div style={{width:'320px',background:'#fff',borderRadius:'12px',border:'1px solid #e5e7eb',overflowY:'auto',flexShrink:0}}>
                <div style={{padding:'16px',borderBottom:'1px solid #e5e7eb',fontWeight:'700',fontSize:'16px',color:'#1e1b4b'}}>Conversations</div>
                {Object.entries(inbox.reduce((acc,m)=>{acc[m.from_phone]=acc[m.from_phone]||[];acc[m.from_phone].push(m);return acc},{})).length>0?
                  Object.entries(inbox.reduce((acc,m)=>{acc[m.from_phone]=acc[m.from_phone]||[];acc[m.from_phone].push(m);return acc},{})).map(([phone,msgs])=>(
                    <div key={phone} onClick={()=>{ setSelectedConvo(phone); fetch(`${API}/mark-read`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,phone})}); }} style={{padding:'14px 16px',borderBottom:'1px solid #f3f4f6',cursor:'pointer',background:selectedConvo===phone?'#eef2ff':'#fff',display:'flex',alignItems:'center',gap:'12px'}}>
                      <div style={{width:'40px',height:'40px',borderRadius:'50%',background:'#6366f1',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:'700',fontSize:'16px',flexShrink:0}}>{contacts.find(c=>c.phone===phone)?.name?.[0]||phone[0]}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:'600',color:'#1e1b4b',fontSize:'14px'}}>{contacts.find(c=>c.phone===phone)?.name||phone}</div>
                        <div style={{fontSize:'12px',color:'#6b7280',marginTop:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{msgs[0].message}</div>
                      </div>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'4px',flexShrink:0}}>
                        <div style={{fontSize:'10px',color:'#9ca3af'}}>{new Date(msgs[0].created_at).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}</div>
                        {msgs.filter(m=>m.direction==='inbound'&&!m.is_read).length>0&&<span style={{background:'#ef4444',color:'#fff',borderRadius:'10px',padding:'1px 6px',fontSize:'11px',fontWeight:'700'}}>{msgs.filter(m=>m.direction==='inbound'&&!m.is_read).length}</span>}
                      </div>
                    </div>
                  ))
                :<div style={{padding:'40px',textAlign:'center',color:'#9ca3af'}}>No conversations yet</div>}
              </div>
              <div style={{flex:1,background:'#fff',borderRadius:'12px',border:'1px solid #e5e7eb',display:'flex',flexDirection:'column'}}>
                {selectedConvo?(
                  <>
                    <div style={{padding:'14px 16px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',gap:'12px'}}>
                      <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'#6366f1',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:'700'}}>{contacts.find(c=>c.phone===selectedConvo)?.name?.[0]||selectedConvo[0]}</div>
                      <div>
                        <div style={{fontWeight:'600',color:'#1e1b4b'}}>{contacts.find(c=>c.phone===selectedConvo)?.name||selectedConvo}</div>
                        <div style={{fontSize:'12px',color:'#6b7280'}}>{selectedConvo}</div>
                      </div>
                    </div>
                    <div style={{flex:1,overflowY:'auto',padding:'16px',display:'flex',flexDirection:'column',gap:'8px'}}>
                      {inbox.filter(m=>m.from_phone===selectedConvo).slice().reverse().map(m=>(
                        <div key={m.id} style={{display:'flex',justifyContent:m.direction==='outbound'?'flex-end':'flex-start'}}>
                          <div style={{maxWidth:'65%',padding:'10px 14px',borderRadius:'12px',background:m.direction==='outbound'?'#6366f1':'#f3f4f6',color:m.direction==='outbound'?'#fff':'#1f2937',fontSize:'13px'}}>
                            {m.message_type==="image"?<img src={m.message} style={{maxWidth:"100%",borderRadius:"8px",marginBottom:"4px"}} alt="img"/>:m.message_type==="document"?<a href={m.message} target="_blank" style={{color:"inherit",textDecoration:"underline",fontSize:"12px"}}>📄 {m.message.split("/").pop()}</a>:<span>{m.message}</span>}
                            <div style={{fontSize:'10px',opacity:'0.7',marginTop:'4px',textAlign:'right'}}>{new Date(m.created_at).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{padding:'12px 16px',borderTop:'1px solid #e5e7eb'}}>
                      <div style={{display:'flex',gap:'8px',marginBottom:'8px'}}>
                        <label style={{cursor:'pointer',padding:'8px 12px',background:'#f3f4f6',borderRadius:'8px',fontSize:'13px',color:'#374151',display:'flex',alignItems:'center',gap:'4px'}}>
                          <span>Image</span>
                          <input type="file" accept="image/*" style={{display:'none'}} onChange={async e=>{const f=e.target.files[0];if(!f)return;const fd=new FormData();fd.append('file',f);fd.append('clientId',user.clientId);fd.append('phone',selectedConvo);fd.append('fileType','image');const r=await fetch(`${API}/send-attachment`,{method:'POST',body:fd});const d=await r.json();if(d.success){const r2=await fetch(`${API}/messages?clientId=${user.clientId}`);const d2=await r2.json();if(d2.success)setInbox(d2.messages);}e.target.value='';}}/>
                        </label>
                        <label style={{cursor:'pointer',padding:'8px 12px',background:'#f3f4f6',borderRadius:'8px',fontSize:'13px',color:'#374151',display:'flex',alignItems:'center',gap:'4px'}}>
                          <span>Document</span>
                          <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx" style={{display:'none'}} onChange={async e=>{const f=e.target.files[0];if(!f)return;const fd=new FormData();fd.append('file',f);fd.append('clientId',user.clientId);fd.append('phone',selectedConvo);fd.append('fileType','document');const r=await fetch(`${API}/send-attachment`,{method:'POST',body:fd});const d=await r.json();if(d.success){const r2=await fetch(`${API}/messages?clientId=${user.clientId}`);const d2=await r2.json();if(d2.success)setInbox(d2.messages);}e.target.value='';}}/>
                        </label>
                      </div>
                      <div style={{display:'flex',gap:'8px'}}>
                        <input style={{...s.input,marginBottom:0,flex:1}} placeholder="Type a reply..." value={replyMsg||''} onChange={e=>setReplyMsg(e.target.value)} onKeyDown={async e=>{if(e.key==='Enter'&&replyMsg){const r=await fetch(`${API}/reply-message`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,phone:selectedConvo,message:replyMsg})});const d=await r.json();if(d.success){setReplyMsg('');const r2=await fetch(`${API}/messages?clientId=${user.clientId}`);const d2=await r2.json();if(d2.success)setInbox(d2.messages);}}}}/>
                        <button style={s.btn()} onClick={async()=>{if(!replyMsg)return;const r=await fetch(`${API}/reply-message`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,phone:selectedConvo,message:replyMsg})});const d=await r.json();if(d.success){setReplyMsg('');const r2=await fetch(`${API}/messages?clientId=${user.clientId}`);const d2=await r2.json();if(d2.success)setInbox(d2.messages);}}}>Send</button>
                      </div>
                    </div>
                  </>
                ):(
                  <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',color:'#9ca3af',fontSize:'14px'}}>Select a conversation to start chatting</div>
                )}
              </div>
            </div>
          )}

          {page==='team'&&(
            <div>
              <div style={s.row}><div style={s.pageTitle}>Team Member</div><button style={s.btn()} onClick={()=>setShowAddMember(!showAddMember)}>+ Add</button></div>
              {showAddMember&&(
                <div style={{...s.card,borderLeft:`4px solid ${P}`}}>
                  <input style={s.input} placeholder="Full Name" value={newMember.name} onChange={e=>setNewMember({...newMember,name:e.target.value})}/>
                  <input style={s.input} placeholder="Email" value={newMember.email} onChange={e=>setNewMember({...newMember,email:e.target.value})}/>
                  <input style={s.input} type="text" placeholder="Password (blank = auto-generate)" value={newMember.password} onChange={e=>setNewMember({...newMember,password:e.target.value})}/>
                  <select style={{...s.input}} value={newMember.role} onChange={e=>setNewMember({...newMember,role:e.target.value})}><option>Agent</option><option>Manager</option><option>Admin</option></select>
                  <button style={s.btn()} onClick={()=>{if(!newMember.name||!newMember.email)return;fetch(API+'/team-members',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,name:newMember.name,email:newMember.email,role:newMember.role||'Agent',password:newMember.password})}).then(r=>r.json()).then(d=>{if(!d.success){alert(d.error||'Add failed');return;}alert('Member added!\nEmail: '+d.member.email+'\nPassword: '+d.tempPassword+'\n\nShare these login details.');setNewMember({name:'',email:'',role:'Agent',password:''});setShowAddMember(false);loadTeam();});}}>Add</button>
                </div>
              )}
              <div style={s.card}>
                <table style={s.table}>
                  <thead><tr><th style={s.th}>#</th><th style={s.th}>Name</th><th style={s.th}>Email</th><th style={s.th}>Role</th><th style={s.th}>Status</th><th style={s.th}>Action</th></tr></thead>
                  <tbody>{team.map(m=>(<tr key={m.id}><td style={s.td}>{m.id}</td><td style={s.td}><b>{m.name}</b></td><td style={s.td}>{m.email}</td><td style={s.td}><span style={s.badge(m.role==='Admin'?P:'#6b7280')}>{m.role}</span></td><td style={s.td}><Toggle on={m.status} onToggle={()=>fetch(API+'/team-members/'+m.id,{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({clientId:user.clientId,status:!m.status})}).then(()=>loadTeam())}/></td><td style={s.td}><button style={s.actionBtn('#dc2626')} onClick={()=>m.role!=='Admin'&&window.confirm('Delete this member?')&&fetch(API+'/team-members/'+m.id+'?clientId='+user.clientId,{method:'DELETE'}).then(()=>loadTeam())}>Del</button></td></tr>))}</tbody>
                </table>
              </div>
            </div>
          )}

          {page==='ticket'&&(<div><div style={s.pageTitle}>My Ticket</div><div style={s.card}><div style={s.emptyBox}><div>No tickets yet.</div></div></div></div>)}
          {page==='ai-chat'&&(<div><div style={s.pageTitle}>AI Assistant</div><div style={s.card}><div style={s.emptyBox}><div>AI Assistant coming soon.</div></div></div></div>)}

          {page==='settings-profile'&&(
            <div>
              <div style={s.pageTitle}>Profile Settings</div>
              <div style={s.card}>
                <label style={s.label}>Full Name</label><input style={s.input} defaultValue={user.name}/>
                <label style={s.label}>Email</label><input style={s.input} defaultValue={user.email}/>
                <label style={s.label}>Company</label><input style={s.input} defaultValue={user.clientName}/>
                <button style={s.btn()}>Save Changes</button>
              </div>
            </div>
          )}

          {page==='settings-billing'&&(
            <div><div style={s.pageTitle}>Billing</div>
            <div style={s.card}><div style={{background:'#eef2ff',borderRadius:'10px',padding:'20px'}}><div style={{fontSize:'16px',fontWeight:'700',color:P}}>Advance Plan</div><div style={{fontSize:'13px',color:'#6b7280',marginTop:'4px'}}>Next billing: 2026-07-15</div></div></div></div>
          )}

          {page==='settings-api'&&(
            <div>
              <div style={s.pageTitle}>API Keys</div>
              <div style={s.card}>
                <div style={{background:'#1e2139',borderRadius:'8px',padding:'16px',marginBottom:'12px'}}>
                  <div style={{fontSize:'11px',color:'#8b9dc3',marginBottom:'4px'}}>PHONE NUMBER ID</div>
                  <div style={{fontSize:'12px',color:'#34d399'}}>{user.phoneId}</div>
                </div>
                <div style={{background:'#1e2139',borderRadius:'8px',padding:'16px'}}>
                  <div style={{fontSize:'11px',color:'#8b9dc3',marginBottom:'4px'}}>WABA ID</div>
                  <div style={{fontSize:'12px',color:'#34d399'}}>{user.wabaId}</div>
                </div>
              </div>
            </div>
          )}

          {page==='api-docs'&&(
            <div>
              <div style={s.pageTitle}>API Documentation</div>
              <div style={s.card}>
                <div style={{background:'#1e2139',borderRadius:'8px',padding:'16px',marginBottom:'12px'}}>
                  <div style={{fontSize:'12px',color:'#8b9dc3',marginBottom:'8px'}}>POST /send-message</div>
                  <pre style={{fontSize:'12px',color:'#34d399',margin:0}}>{`{\n  "phone": "966XXXXXXXXX",\n  "message": "Hello!",\n  "clientId": "${user.clientId}"\n}`}</pre>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}